import {Component, Input, ViewChild} from '@angular/core';
import {NgClass} from '@angular/common';
import {KENDO_INPUTS, NumericTextBoxComponent} from '@progress/kendo-angular-inputs';
import {CompositeFilterDescriptor} from '@progress/kendo-data-query';
import {filterClearIcon, SVGIcon} from '@progress/kendo-svg-icons';
import {BaseFilterCellComponent, ColumnComponent, FilterCellOperatorsComponent, FilterService} from '@progress/kendo-angular-grid';
import {KENDO_BUTTONS} from '@progress/kendo-angular-buttons';
import {FormsModule} from '@angular/forms';

//Composant filtre rapide numérique
@Component (
{
  selector: 'val-numerique-filtre-rapide',
  imports: 
  [
    FormsModule,
    NgClass,
    KENDO_INPUTS,
    KENDO_BUTTONS,
    NumericTextBoxComponent,
    FilterCellOperatorsComponent
  ],
  templateUrl: './numerique-filtre-rapide.component.html',
  styleUrl: './numerique-filtre-rapide.component.scss',
})
export class NumeriqueFiltreRapideComponent extends BaseFilterCellComponent 
{
  //Création
  //  Paramètres
  //    filterService : Service filtre
  constructor (filterService: FilterService) 
  {
    super (filterService);

    this.boutonEffacerVisible = false;
    this.boutonEffacerIcone = filterClearIcon;
    this.format = "n0";
    this.nombreDecimale = 0;
    this.valeur = null;
    this.operateur = "eq";
  }

  //Editeur
  @ViewChild ("editeurNumerique")
  public editeurNumerique!: NumericTextBoxComponent;

  //Description des filtres
  @Input()
  public override filter!: CompositeFilterDescriptor;

  //Nom du champ
  @Input ()
  public nomChamp!: string;

  //Format
  @Input ()
  public format: string;

  //Nombre de décimale
  @Input ()
  public nombreDecimale: number;

  //Format de saisie (sans séparateur de milliers)
  public get formatSaisie () : string
  {
    return this.nombreDecimale === 0 ? '0' : '0.' + '0'.repeat (this.nombreDecimale);
  }

  @Input ()
  public column!: ColumnComponent;

  //Indique si le bouton effacer est visible
  public boutonEffacerVisible: boolean;

  //Icone du bouton effacer
  public boutonEffacerIcone: SVGIcon;

  //Valeur
  public valeur: number | null;

  //Opérateur
  public operateur: string;

  //Retourne la valeur sélectionnée
  public get selectedValue () : any 
  {
    const filter = this.filterByField (this.nomChamp);

    return filter ? filter.value : null;
  }

  //Après l’initialisation du contenu
  public override ngAfterContentInit() : void 
  {
    const filter = this.filterByField (this.nomChamp);

    if (filter)
    {
      this.valeur = filter.value;
      this.operateur = filter.operator as string;
      this.boutonEffacerVisible = true;
    }
  }

  //Change la valeur du filtre
  public ChangerValeurFiltre () 
  {
    if (this.valeur === null)
      this.applyFilter (this.removeFilter (this.nomChamp));
    else
    {
      this.applyFilter (this.updateFilter (
                      {
                        field: this.nomChamp,
                        operator: this.operateur,
                        value: this.valeur.toString ()
                      })
      );
    }

    if (this.valeur !== null)
      this.boutonEffacerVisible = true;
  }

  //Traite la fermeture de la popup
  public TraiterFermeturePopUp () : void 
  {
    setTimeout (() => {this.editeurNumerique.blur ();}, 50);
  }

  //Efface l’éditeur
  public Effacer () : void 
  {
    this.valeur = null;

    this.applyFilter (this.removeFilter (this.nomChamp));

    this.boutonEffacerVisible = false;
  }

  //Traite le clavier
  //  Paramètres
  //    evenementClavier : Données de l’événement clavier
  public TraiterClavier (evenementClavier: KeyboardEvent) : void 
  {
    if (evenementClavier.key === "Enter")
      this.ChangerValeurFiltre ();
  }

  //Change l’opérateur
  public ChangerOperateur () : void 
  {
    setTimeout (() => {this.ChangerValeurFiltre ();}, 50);    
  }
}
